define('shared/remote/member/studentType',[
    'shared/remote/ajax',
    'shared/lib/RSVP'
], 
function(
    ajax, 
    RSVP
) {
    return function(){
        return RSVP.resolve()
            .then(function(){
                return ajax({
                    url: '/1/api/commerce-gateway/member/student-type',
                    method: 'get'
                });
            })
            .then(function(json){
                return json;
            }, function(xhr) {
                if (xhr && xhr.status === 404) {
                    return null;
                }

                return RSVP.reject(xhr);
            });
    };
});
